export default __webpack_public_path__ + "static/media/KidcoGrillGuide2@2x.51ce9cbb.jpg";